import type {
  ActionSource,
  ActionSourceChatbot,
  ABTEventsSchema,
  ABTPossibleRelations,
  ActionSourceVoicebot,
  ActionSourceSurveyV2,
} from 'src/types/audience-actions';
import type {AbtAttributesAction} from 'src/action-creators/action-based-targeting-meta';
import {
  RECEIVE_ABT_EVENTS,
  RECEIVE_ABT_RELATIONS,
  RECEIVE_JOURNEYS_ACTION,
  RECEIVE_CHATBOTS_ACTION,
  RECEIVE_WORKFLOWS_ACTION,
  RECEIVE_VOICEBOTS_ACTION,
  RECEIVE_SURVEY_V2_ACTION,
} from 'src/action-creators/audience-actions';


export type State = {
  events: ABTEventsSchema;
  relations: ABTPossibleRelations;
  sourceLimit: number;
  journeysMap: Map<string, Array<ActionSource>>;
  workflowsMap: Map<string, Array<ActionSource>>;
  chatbotsMap: Map<string, Array<ActionSourceChatbot>>;
  voicebotsMap: Map<string, Array<ActionSourceVoicebot>>;
  surveyV2Map: Map<string, Array<ActionSourceSurveyV2>>;
  totalJourneysCount: number;
  totalWorkflowsCount: number;
  totalChatbotsCount: number;
  totalVoicebotsCount: number;
  totalSurveyV2Count: number;
};

const initialState = {
  events: [],
  relations: {},
  sourceLimit: 0,
  journeysMap: new Map(),
  workflowsMap: new Map(),
  chatbotsMap: new Map(),
  voicebotsMap: new Map(),
  surveyV2Map: new Map(),
  totalJourneysCount: 0,
  totalChatbotsCount: 0,
  totalSurveyV2Count: 0,
  totalWorkflowsCount: 0,
  totalVoicebotsCount: 0,
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly events: readonly []; readonly relations: {}; readonly sourceLimit: 0; readonly journeysMap: Map<any, any>; readonly workflowsMap: Map<any, any>; readonly chatbotsMap: Map<any, any>; ... 6 more ...; readonly totalVoicebotsCount: 0; }' is not assignable to type 'State'.
  state: State | null | undefined = initialState,
  action: AbtAttributesAction,
): State => {
  switch (action.type) {
    // @ts-expect-error - TS2678 - Type '"audience-actions/receive-events"' is not comparable to type '"abt-attributes/receiveAll"'.
    case RECEIVE_ABT_EVENTS: {
      // @ts-expect-error - TS2339 - Property 'events' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'sourceLimit' does not exist on type 'ActionAttributeSchema[]'.
      const {events, sourceLimit} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ events: any; sourceLimit: any; relations?: ABTPossibleRelations | undefined; journeysMap?: Map<string, ActionSource[]> | undefined; workflowsMap?: Map<...> | undefined; ... 7 more ...; totalSurveyV2Count?: number | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        events,
        sourceLimit,
      };
    }
    // @ts-expect-error - TS2678 - Type '"audience-actions/receive-relations"' is not comparable to type '"abt-attributes/receiveAll"'.
    case RECEIVE_ABT_RELATIONS: {
      return {
        ...state,
        // @ts-expect-error - TS2322 - Type 'ActionAttributeSchema[]' is not assignable to type 'ABTPossibleRelations'.
        relations: action.payload,
      };
    }
    // @ts-expect-error - TS2678 - Type '"audience-actions/receive-journeys"' is not comparable to type '"abt-attributes/receiveAll"'.
    case RECEIVE_JOURNEYS_ACTION: {
      // @ts-expect-error - TS2339 - Property 'journeys' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'pageNumber' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'isNew' does not exist on type 'ActionAttributeSchema[]'.
      const {journeys, pageNumber, isNew} = action.payload;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const tempJourneysMap = isNew ? new Map() : new Map(state.journeysMap);
      // @ts-expect-error - TS2322 - Type '{ journeysMap: Map<any, any>; totalJourneysCount: any; events?: ABTEventsSchema | undefined; relations?: ABTPossibleRelations | undefined; ... 8 more ...; totalSurveyV2Count?: number | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        journeysMap: tempJourneysMap.set(pageNumber, journeys),
        // @ts-expect-error - TS2339 - Property 'totalCount' does not exist on type 'ActionAttributeSchema[]'.
        totalJourneysCount: action.payload.totalCount,
      };
    }
    // @ts-expect-error - TS2678 - Type '"audience-actions/receive-workflows"' is not comparable to type '"abt-attributes/receiveAll"'.
    case RECEIVE_WORKFLOWS_ACTION: {
      // @ts-expect-error - TS2339 - Property 'workflows' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'pageNumber' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'isNew' does not exist on type 'ActionAttributeSchema[]'.
      const {workflows, pageNumber, isNew} = action.payload;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const tempWorkflowsMap = isNew ? new Map() : new Map(state.workflowsMap);
      // @ts-expect-error - TS2322 - Type '{ workflowsMap: Map<any, any>; totalWorkflowsCount: any; events?: ABTEventsSchema | undefined; relations?: ABTPossibleRelations | undefined; ... 8 more ...; totalSurveyV2Count?: number | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        workflowsMap: tempWorkflowsMap.set(pageNumber, workflows),
        // @ts-expect-error - TS2339 - Property 'totalCount' does not exist on type 'ActionAttributeSchema[]'.
        totalWorkflowsCount: action.payload.totalCount,
      };
    }
    // @ts-expect-error - TS2678 - Type '"audience-actions/receive-chatbots"' is not comparable to type '"abt-attributes/receiveAll"'.
    case RECEIVE_CHATBOTS_ACTION: {
      // @ts-expect-error - TS2339 - Property 'chatbots' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'pageNumber' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'isNew' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'totalCount' does not exist on type 'ActionAttributeSchema[]'.
      const {chatbots, pageNumber, isNew, totalCount} = action.payload;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const tempChatbotsMap = isNew ? new Map() : new Map(state.chatbotsMap);
      // @ts-expect-error - TS2322 - Type '{ chatbotsMap: Map<any, any>; totalChatbotsCount: any; events?: ABTEventsSchema | undefined; relations?: ABTPossibleRelations | undefined; ... 8 more ...; totalSurveyV2Count?: number | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        chatbotsMap: tempChatbotsMap.set(pageNumber, chatbots),
        totalChatbotsCount: totalCount,
      };
    }
    // @ts-expect-error - TS2678 - Type '"audience-actions/receive-voicebots"' is not comparable to type '"abt-attributes/receiveAll"'.
    case RECEIVE_VOICEBOTS_ACTION: {
      // @ts-expect-error - TS2339 - Property 'voicebots' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'pageNumber' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'isNew' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'totalCount' does not exist on type 'ActionAttributeSchema[]'.
      const {voicebots, pageNumber, isNew, totalCount} = action.payload;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const tempVoicebotsMap = isNew ? new Map() : new Map(state.voicebotsMap);
      // @ts-expect-error - TS2322 - Type '{ voicebotsMap: Map<any, any>; totalVoicebotsCount: any; events?: ABTEventsSchema | undefined; relations?: ABTPossibleRelations | undefined; ... 8 more ...; totalSurveyV2Count?: number | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        voicebotsMap: tempVoicebotsMap.set(pageNumber, voicebots),
        totalVoicebotsCount: totalCount,
      };
    }
    // @ts-expect-error - TS2678 - Type '"audience-actions/receive-survey-v2"' is not comparable to type '"abt-attributes/receiveAll"'.
    case RECEIVE_SURVEY_V2_ACTION: {
      // @ts-expect-error - TS2339 - Property 'surveyV2' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'pageNumber' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'isNew' does not exist on type 'ActionAttributeSchema[]'. | TS2339 - Property 'totalCount' does not exist on type 'ActionAttributeSchema[]'.
      const {surveyV2, pageNumber, isNew, totalCount} = action.payload;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const tempSurveyV2Map = isNew ? new Map() : new Map(state.surveyV2Map);
      // @ts-expect-error - TS2322 - Type '{ surveyV2Map: Map<any, any>; totalSurveyV2Count: any; events?: ABTEventsSchema | undefined; relations?: ABTPossibleRelations | undefined; ... 8 more ...; totalVoicebotsCount?: number | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        surveyV2Map: tempSurveyV2Map.set(pageNumber, surveyV2),
        totalSurveyV2Count: totalCount,
      };
    }
  }
  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
};
